"use client"

import { ChildContainerProps } from "@/types/types";
// import { GoogleReCaptchaProvider } from "@google-recaptcha/react";


const Providers = ({ children }: ChildContainerProps) => (
    <div>
      {children}
    </div>
)

export { Providers }